import { get } from '@/api/request'

export default {
  loadUserAbilities: (success, failure) => get(
    '/api/user-abilities',
    success, failure
  ),
  loadTaskAbilities: (taskId, success, failure) => get(
    `/api/abilites/task/${taskId}`,
    success, failure
  ),
  loadProjectAbilities: (taskId, success, failure) => get(
    `/api/abilites/project/${taskId}`,
    success, failure
  ),
}